/* eslint-disable indent */
/* eslint-disable max-lines-per-function */
import React, { Component } from 'react';
import { Card } from 'primereact/card';
import fundo_amarelo from '../../assets/fundo_amarelo.png';
import { Fieldset } from 'primereact/fieldset';
import * as moment from 'moment';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Dropdown } from 'primereact/dropdown';
import { BuscarAssoc, UpdateAssoc, EditarValorDinamicoAssoc } from '../../services/associados';
import { BuscarProduto, getProducts } from '../../services/produtos/index';
import { showMessageSuccess, showMessageError } from '../others/toastr';
import 'toastr/build/toastr.min.js';
import 'toastr/build/toastr.css';
import { BuscaAceiteUnico } from '../../services/assinaturas';
import { InputMask } from 'primereact/inputmask';
import { ProgressSpinner } from 'primereact/progressspinner';
import { api } from '../../services/contratoApi/index';
import { InputTextarea } from 'primereact/inputtextarea';
import { BuscaInscricao } from '../../services/inscricao';
import { BuscarDependentes } from '../../services/dependentes';
import { BuscarCep } from '../../modulos/Cep';
import apiZelo from '../../services/backAxiosVendaToken';
import {
    opPagamento,
    opPagamentoParaES,
    opPagamentoPrime,
    opPagamentoParaESPrime,
    opPagamentoParaESSemBoleto,
    opSexo,
    opCidadesZPETNExterno
} from '../cadastrar-contratos/opcoesDropdown';
import { atualizarAdesao } from '../../modulos/atualizarAdesao';
import { somaTotalDependentes } from '../../modulos/function/somaTotalDependentes';
import { DialogVerificacaoPlano } from '../dialogs/dialogVerificacaoPlano/index.jsx';
import { montaObjetoParaUpdateAssociado } from '../../modulos/function/montaObjetoAssociado';
import {
    filtroDependentesDeOutrosTipos,
    filtroDependentesDiferenteConjuge,
    filtroDependentesSemValor,
    filtroDependentesTipoConjugeSemValor
} from '../../modulos/function/filtroTipoDependentes';
import ValidacaoDependenteEditarContrato from './validarEstruturaDependentesPorPlano';
import { buscaNomeCemiterio } from '../cadastrar-contratos/helpers/buscaNomeCemiterio';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import ModalValidacaoAceite from './modalValidacaoAceite';
import ModalPlanoDesativado from '../modalPlanoDesativado/modalPlanoDesativado';
import { Dialog } from 'primereact/dialog';
import { GoAlert } from 'react-icons/go';
import { subGruposValidos } from '../cadastrar-contratos/TipoCobranca.jsx';
import {
    atuatualizarAssociadoUpSell,
    atuatualizarLogUpSell,
    buscarAssociadoUpSell,
    buscarContratoUpSellPorInscricao
} from '../../services/upSell/index.js';
import getTipoColaborador from '../../helpers/getTipoColaborador.js';
import { refactoryDadosAssociadoUpSellEntrada } from './funcoesAuxiliares.js';

const area = decriptoLocalStorage('area')?.decriptoValue;
const initialState = {
    associados: '',
    dados: {
        DiaVenc: moment().format('DD'),
        AssTipoCobranca: '',
        SubGrupo: ''
    },
    dadosOriginaisAntesDaEdicao: {
        DiaVenc: moment().format('DD'),
        AssTipoCobranca: '',
        SubGrupo: ''
    },
    sucesso: false,
    erro: false,
    produtos: [],
    cidades: [],
    mensagem: '',
    aceiteEletronico: '',
    spinner: true,
    produtosTemp: [],
    dependentes: [],
    editavel: true,
    pagInscricao: false,
    desabilitarBotao: false,
    ufLocation: '',
    codeIbge: '',
    setGrupoRegiao: [],
    dropdownSuGrupoData: '',
    ValorBase: '',
    produtoPrecoValorBase: 0,
    selectionSubGrupo: '',
    dadosCep: [],
    opcoesPagamento: [],
    modalPlano: false,
    foraDicionario: false,
    arrayMsgErroDependente: [],
    subGrupoInicial: '',
    valorRg: '',
    nomeCemiterio: [],
    valorTrocaAberta: '',
    visible: false
};
let inscricao1;
let coordenador;
let supervisor;
let vendedor;
let tipoColaborador;

const opMensalidade = [
    {
        label: 'Mensal',
        value: 'M'
    },
    {
        label: 'Anual',
        value: 'A'
    },
    {
        label: '4 Anos',
        value: 'AT'
    }
];

const opMensalidadeZPC = [
    {
        label: 'Mensal',
        value: 'M'
    },
    {
        label: 'Anual',
        value: 'A'
    },
    {
        label: '4 Anos',
        value: '4'
    }
];

class editarAssociados extends Component {
    state = {
        ...initialState,
        subGrupoSelecionadoUpSell: null,
        existeUpSellContrato: null,
        titulo: 'Editar Associado',
        dadosAssociadoComUpSell: {
            DiaVenc: 0,
            AssEmail: '',
            Celular: '',
            Telefone: '',
            numeroResidencia: 0,
            Cidade: '',
            Bairro: '',
            Residencia: '',
            Complemento: '',
            AssReferenciaEndereco: 'N/A',
            Obs1: ''
        }
    };

    handleInputChange = e => {
        const inputValue = e.target.value;
        const cleanedValue = inputValue.replace(/[^0-9.,]/g, '');
        const valueWithPoints = cleanedValue.replace(/,/g, '.');
        const valueFormated = valueWithPoints.replace(/(\..*)\./g, '$1');

        this.updatedField({
            target: {
                name: e.target.name,
                value: valueFormated
            }
        });
    };

    async componentDidMount() {
        coordenador = decriptoLocalStorage('codSupervisor')?.decriptoValue;
        supervisor = decriptoLocalStorage('codCoordenador')?.decriptoValue;
        vendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
        tipoColaborador = getTipoColaborador(decriptObjectOnLocalStorage('PERM'));

        const { inscricao } = this.props.match.params;

        const response = await buscarContratoUpSellPorInscricao(vendedor, tipoColaborador, inscricao);
        const detalheUpSell = await response?.data;
        const subGrupoDestino = detalheUpSell?.subGrupoDestino;

        function formatarSubGrupoDestino(subGrupoDestino) {
            const espacosNecessarios = 5 - subGrupoDestino.length;
            const espacos = ' '.repeat(espacosNecessarios);

            return subGrupoDestino + espacos;
        }

        if ((detalheUpSell?.status === null || detalheUpSell?.status === 'RECUSADO') && subGrupoDestino) {
            const resultAssociadoUpSell = await buscarAssociadoUpSell(inscricao);

            if (resultAssociadoUpSell) {
                const existedeDadosCepEditadoLocalStorage = decriptObjectOnLocalStorage('cep_associado_up_sell');
                const dadosCepEditadoLocalStorage = existedeDadosCepEditadoLocalStorage ?
                    JSON.parse(existedeDadosCepEditadoLocalStorage) : null;

                this.setState(prevState => ({
                    subGrupoSelecionadoUpSell: formatarSubGrupoDestino(subGrupoDestino),
                    existeUpSellContrato: true,
                    titulo: 'Editar Associado UpSell',
                    dados: {
                        ...prevState.dados,
                        AssTipoCobranca: '7'
                    },
                    dadosAssociadoComUpSell:
                        refactoryDadosAssociadoUpSellEntrada(
                            prevState.dadosAssociadoComUpSell, resultAssociadoUpSell, dadosCepEditadoLocalStorage)
                }));
                this.setState({ existeUpSellContrato: true });
            }
        }

        inscricao1 = inscricao;

        await BuscarDependentes(inscricao)
            .then(resp => {
                this.setState({ dependentes: resp });
            })
            .catch(err => {
                console.log(err);
            });

        await BuscarAssoc(inscricao)
            .then(response => {
                this.CEP(response[0].CEPResid);

                if (
                    response[0].Grupo.trim() !== 'PRE' ||
                    response[0].Aceite.trim() === 'S'
                ) {
                    this.setState({ editavel: false });
                }

                if (response[0].Carencia != null) {
                    response[0].Carencia = response[0].Carencia.toString();
                }

                const resta = response;

                if (resta != null) {
                    for (let i = 0; i < resta.length; i++) {
                        if (resta[i]['Nascimento'] != null) {
                            resta[i].Nascimento = moment(resta[i]['Nascimento'])
                                .add(3, 'hours')
                                .format('DD-MM-YYYY');
                        }
                    }
                }

                if (response[0].SubGrupo.trim() == 'ZP4') {
                    response[0].payzentipomensalidade = 'AT';
                    response[0].SubGrupo = response[0].SubGrupo.trim();
                }

                if (response[0].SubGrupo.trim() == 'ZPA') {
                    response[0].payzentipomensalidade = 'A';
                    response[0].SubGrupo = response[0].SubGrupo.trim();
                }

                if (
                    response[0].SubGrupo.trim() === 'ZS' ||
                    response[0].SubGrupo.trim() === 'ZSUC'
                ) {
                    this.handleBuscaCemiterio(response[0].SubGrupo.trim());
                }

                const dadosAssociado = response[0];

                if (
                    !dadosAssociado.Complemento ||
                    dadosAssociado.Complemento.toUpperCase() === 'NULL'
                ) {
                    dadosAssociado.Complemento = '';
                }

                if (
                    !dadosAssociado.Obs1 ||
                    dadosAssociado.Obs1.toUpperCase() === 'NULL'
                ) {
                    dadosAssociado.Obs1 = ' ';
                }

                if (this.state.existeUpSellContrato) {
                    dadosAssociado.SubGrupo = subGrupoDestino;
                }

                this.setState({
                    dados: dadosAssociado,
                    dadosOriginaisAntesDaEdicao: dadosAssociado,
                    spinner: false
                });
            })
            .catch(() => {
                this.setState({ spinner: true });
            });

        await BuscarProduto()
            .then(response => {
                if (response) {
                    response.forEach(element => {
                        element.label = element.descricao;
                        element.value = element.SubGrupo;
                    });
                    this.setState({ produtos: response });
                    this.setState({ produtosTemp: response });
                }
            })
            .catch(erro => {
                throw new Error(erro);
            });

        await BuscaInscricao(inscricao)
            .then(result => {
                if (result.Pagamento && result.Pagamento !== null) {
                    this.setState({ pagInscricao: true });
                }
            })
            .catch(erro => {
                throw new Error(erro);
            });

        await BuscaAceiteUnico(inscricao)
            .then(resp => {
                if (resp.length > 0) {
                    this.setState({ aceiteEletronico: true });
                }
            })
            .catch(err => err);

        const subGrupoContrato = this.state.dados.SubGrupo;

        this.setState({ subGrupoInicial: subGrupoContrato });
        this.setState({ selectionSubGrupo: subGrupoContrato });
        this.buscaOpcaoPagamento(subGrupoContrato);
        this.setValorBaseProduto(this.state.selectionSubGrupo);
        this.verificaRegrasParaPlanoZI(this.state.selectionSubGrupo);
        this.verificarRegrasParaPlanoZeloSobMedida(this.state.selectionSubGrupo);
        this.atualizaProdutosFiltrados();
        this.setState({ valorTrocaAberta: this.state.dados['ProdutosPreco.valorBase'].toString() });
    }

    cemiterioEstadoZS(cemiterios) {
        const cidadeCodigo = {
            MG: '31',
            TO: '17',
            CE: '23'
        };

        return cemiterios.filter(
            cemiterio =>
                String(cemiterio.codIBGE).trim().substr(0, 2) ==
                cidadeCodigo[this.state.ufLocation]
        );
    }

    async handleBuscaCemiterio(subGrupo) {
        let cemiterios = await buscaNomeCemiterio(subGrupo);

        if (Array.isArray(cemiterios)) {
            cemiterios = this.cemiterioEstadoZS(cemiterios);
            this.setState({
                nomeCemiterio: cemiterios.map(value => ({
                    label: value.cemiterio,
                    value: value.id
                }))
            });
        }
    }

    updatedField(event) {
        const dados = { ...this.state.dados };

        dados[event.target.name] = event.target.value;
        this.setState({ dados });
    }

    updatedFieldUpSell(event) {
        const dadosAssociadoComUpSell = { ...this.state.dadosAssociadoComUpSell };

        dadosAssociadoComUpSell[event.target.name] = event.target.value;
        this.setState({ dadosAssociadoComUpSell });
    }

    validaRG(event) {
        this.updatedField(event);
        this.setState({ valorRg: '' });

        return true;
    }

    reload() {
        const previousUrl = document.referrer.split('/')[3];
        const { inscricao } = this.props.match.params;

        if (previousUrl === 'assinatura') {
            window.location.href = `/assinatura/${inscricao}`;
        } else if (previousUrl === 'cadastrar-dependentes') {
            window.location.href = `/cadastrar-dependentes/${inscricao}`;
        } else {
            window.location.href = '/lista-contratos';
        }
    }

    verificaRegrasParaPlanoZI(subGrupo) {
        if (this.state.dependentes.length > 0) {
            const somaValorTotalDependentes = somaTotalDependentes(
                this.state.dependentes
            );

            if (subGrupo.trim() === 'ZI') {
                if (
                    somaValorTotalDependentes > 0 ||
                    this.state.dependentes.length > 5
                ) {
                    this.setState({ modalPlano: true });
                    this.setState({ desabilitarBotao: true });
                }
            }
        }
    }

    verificaRegrasParaPlanoZTA(subGrupo, subGrupoDoPlanoAtual) {
        if (subGrupoDoPlanoAtual === 'ZTA' && this.state.dependentes.length) {
            const msgErroDependentes = [
                'Para mudar de plano, é preciso remover todos os dependentes atuais, já que as condições do novo plano, Zelo Troca Aberta, não se aplicam aos dependentes de outros planos.'
            ];

            this.setState({
                arrayMsgErroDependente: msgErroDependentes,
                foraDicionario: true
            });
            this.setState({ modalPlano: true });

            return;
        }
    }

    verificarRegrasParaPlanoZeloSobMedida(subGrupo) {
        if (
            this.state.dependentes.length > 0 &&
            subGrupo.trim().substr(0, 2) === 'ZU'
        ) {
            const listaDeDependentes = this.state.dependentes;
            const dependentesSemValor = filtroDependentesSemValor(listaDeDependentes);

            const dependentesTipoConjugeSemValor =
                filtroDependentesTipoConjugeSemValor(listaDeDependentes);

            const dependentesSemValorDiferenteConjuge =
                filtroDependentesDiferenteConjuge(listaDeDependentes);

            const dependentesDeOutrosTipos =
                filtroDependentesDeOutrosTipos(listaDeDependentes);

            if (
                (dependentesSemValor.length > 0 &&
                    dependentesTipoConjugeSemValor.length > 1) ||
                (dependentesSemValor.length > 0 &&
                    dependentesSemValorDiferenteConjuge.length > 0)
            ) {
                this.setState({ modalPlano: true });
                this.setState({ desabilitarBotao: true });
            } else if (dependentesDeOutrosTipos.length > 0) {
                this.setState({ desabilitarBotao: true });
                this.setState({ modalPlano: true });
            }
        }
    }

    closeModalPlanoZI() {
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.dados.SubGrupo = this.state.subGrupoInicial;
        this.setState({ modalPlano: false });
        this.setState({ selectionSubGrupo: this.state.subGrupoInicial });
    }

    setValorBaseProduto(grupoSelecionado) {
        const subGrupoSelecionado = this.state.produtosTemp.find(
            produto => produto.SubGrupo.trim() === grupoSelecionado.trim()
        );
        const valorBase = subGrupoSelecionado?.valor;

        this.setState({ produtoPrecoValorBase: valorBase });
    }

    async save() {
        const dadosAssoc2 = montaObjetoParaUpdateAssociado(this.state.dados);

        if (this.state.subGrupoInicial !== dadosAssoc2.SubGrupo) {
            const classeValidacao = new ValidacaoDependenteEditarContrato(
                this.state.dados.SubGrupo.trim(),
                dadosAssoc2.SubGrupo.trim(),
                this.state.dependentes,
                dadosAssoc2
            );

            const msgErroDependentes = await classeValidacao.validarTroca();

            if (msgErroDependentes.length > 0) {
                this.setState({
                    arrayMsgErroDependente: msgErroDependentes,
                    foraDicionario: true
                });
                this.setState({ modalPlano: true });

                return;
            }
        }

        const totalDependentes = somaTotalDependentes(this.state.dependentes);
        const inscricaoAssociado = this.props.match.params.inscricao;
        const associado = {
            ...this.state.dados,
            SubGrupo: this.state.selectionSubGrupo,
            ['ProdutosPreco.valorBase']: this.state.produtoPrecoValorBase
        };

        this.setState({ spinner: true });

        if (this.state.editavel === false || this.state.pagInscricao === true) {
            this.setState({ spinner: false });
            this.setState({ erro: true });
            this.setState({ mensagem: 'Esse contrato não pode ser editado' });

            return 0;
        }

        const dadosAssoc = montaObjetoParaUpdateAssociado(this.state.dados);
        const auxDadosAssociado = JSON.parse(JSON.stringify(dadosAssoc));

        auxDadosAssociado.codigoIbge = this.state.codeIbge;
        auxDadosAssociado.inscricao = inscricaoAssociado;
        auxDadosAssociado.dadosOriginaisAntesDaEdicao =
            this.state.dadosOriginaisAntesDaEdicao;
        await atualizarAdesao(
            inscricaoAssociado,
            associado,
            totalDependentes,
            0,
            auxDadosAssociado
        );

        if (
            dadosAssoc.idDescontoEspecial !== null &&
            dadosAssoc.AssTipoCobranca === 1
        ) {
            dadosAssoc.idDescontoEspecial = null;
        }

        const datatual = moment().add(3, 'hours').format('L');
        const subgru = this.state.selectionSubGrupo ?
            this.state.selectionSubGrupo :
            dadosAssoc.SubGrupo.trim();
        const cidade = dadosAssoc.Cidade;
        let assEmail = dadosAssoc.AssEmail;
        const diaa = moment(new Date()).add(3, 'months').format('YYYY-MM-DD');
        const Nasci = dadosAssoc.Nascimento;

        dadosAssoc.CEPResid = dadosAssoc.CEPResid.replace(/\D/g, '');
        dadosAssoc.Nascimento = moment(Nasci, 'DD-MM-YYYY')
            .add(3, 'hours')
            .format('YYYY-MM-DD');
        dadosAssoc.Grupo = 'PRE';
        dadosAssoc.Nome = dadosAssoc.Nome.toUpperCase();
        dadosAssoc.Data = datatual;
        dadosAssoc.SubGrupo = subgru;
        dadosAssoc.CarenAtend = diaa;
        dadosAssoc.CarenFuneral = diaa;
        dadosAssoc.payzentipomensalidade =
            dadosAssoc.payzentipomensalidade == 'AT' ?
                'A' :
                dadosAssoc.payzentipomensalidade;

        const codIbge = this.state.codeIbge;

        await api.get(`/cidades/ibge/${codIbge}`).then(res => {
            if (res.data) {
                dadosAssoc.Cidade = res.data.Codigo;
            }
        });

        if (assEmail) {
            assEmail = assEmail.replace(/\s/g, '');
            dadosAssoc.AssEmail = assEmail;
        }

        if (this.state.dados.SubGrupo.trim() === 'ZTA') {
            if (
                this.state.dados['ProdutosPreco.valorBase'] === undefined ||
                this.state.dados['ProdutosPreco.valorBase'].trim() === ''
            ) {
                this.setState({
                    erro: true,
                    mensagem: 'Valor para troca aberta não pode ficar vazio!'
                });
                showMessageError('Erro', 'Valor para troca aberta não pode ficar vazio!');
                this.setState({ spinner: false });

                return;
            }
        }

        if (assEmail && assEmail.toLowerCase().includes('@grupozelo')) {
            this.setState({
                erro: true,
                mensagem: '@grupozelo.com não é um domínio permitido!'
            });
            showMessageError('Erro', '@grupozelo.com não é um domínio permitido!');
            this.setState({ spinner: false });

            return;
        }

        if (this.state.dados.SubGrupo?.trim() === 'ZS' || this.state.dados.SubGrupo?.trim() === 'ZSUC') {
            if (this.state.dados.idCemiterio === '' || this.state.dados.idCemiterio === null) {
                showMessageError('Erro', 'Cemitério é um campo obrigatório!');
                this.setState({ spinner: false });

                return;
            }
        }

        dadosAssoc.valor_base = this.state.ValorBase ?
            Number(this.state.ValorBase) :
            dadosAssoc.valor_base;

        if (dadosAssoc.EstadoCivil === 0) {
            dadosAssoc.EstadoCivil = null;
        }

        if (dadosAssoc.Profissao && dadosAssoc.Profissao === 'a') {
            dadosAssoc.Profissao = null;
        }

        if (!dadosAssoc.Telefone) {
            dadosAssoc.Telefone = '(00) 0000-0000';
        }

        const inscricao = inscricao1;
        const valorRg = this.state.valorRg;

        try {
            await UpdateAssoc(inscricao, dadosAssoc);

            if (this.state.dados.SubGrupo.trim() === 'ZTA') {
                const valor = this.state.dados['ProdutosPreco.valorBase'];

                const valorEditado = valor.replace(/,/g, '.');

                await EditarValorDinamicoAssoc(inscricao, { valor: valorEditado });
            }

            await apiZelo.put('/mensalidades/atualiza-mensalidades', { inscricao });

            this.setState({
                spinner: false,
                sucesso: true,
                erro: false
            });

            showMessageSuccess('Sucesso!', 'Você será redirecionado para a página anterior.');
            setTimeout(() => this.reload(), 1000);
        } catch (err) {
            this.setState({ spinner: false });

            if (err.message === 'Dados inválidos!' || valorRg.length < 5) {
                this.setState({
                    erro: true,
                    mensagem: err.message
                });
                showMessageError('Erro', err.message);
            }

            if (err.response && err.response.status) {
                const { status, data } = err.response;

                if (status === 422) {
                    this.setState({ erro: true });

                    if (data.error.details[0].path[0] === 'MaeAssoc') {
                        this.setState({ mensagem: 'Mãe Associado' });
                    }

                    if (data.error.details[0].path[0] === 'AssEmail') {
                        this.setState({ mensagem: 'Email' });
                    }

                    if (data.error.details[0].path[0] === 'RG') {
                        this.setState({ mensagem: 'Erro no RG' });
                    }

                    if (data.error.details[0].path[0] === 'PaiAssoc') {
                        this.setState({ mensagem: 'Pai Associado' });
                    } else {
                        this.setState({
                            mensagem: data.error.details[0].path
                        });
                    }
                } else if (status === 500) {
                    showMessageError('Erro', 'Por favor, tente novamente!');
                }
            }
        }
    }

    async saveUpSell() {
        const dadosAssociadoComUpSell = { ...this.state.dadosAssociadoComUpSell };

        const inscricao = this.props.match.params.inscricao;

        if (['ZSUC', 'ZS'].includes(this.state.dados.SubGrupo?.trim())) {
            let idCemiterioFluxoUpSell = null;
            const idCemiterioMG = 2;
            const idCemiterioTO = 1;

            const Uf = dadosAssociadoComUpSell.UF ?? this.state.dados.UF;

            if (Uf === 'TO') {
                idCemiterioFluxoUpSell = idCemiterioTO;
            } else if ((Uf === 'MG')) {
                idCemiterioFluxoUpSell = idCemiterioMG;
            }

            const body = {
                idCemiterio: idCemiterioFluxoUpSell
            };

            const infoVendedor = {
                tipo: getTipoColaborador(decriptObjectOnLocalStorage('PERM')),
                codigo: decriptoLocalStorage('codigo_vendedor')?.decriptoValue,
                inscricao
            };

            await atuatualizarLogUpSell(infoVendedor, body);
        }

        dadosAssociadoComUpSell.AssTipoCobranca = 7;
        delete dadosAssociadoComUpSell.UF;
        await atuatualizarAssociadoUpSell(inscricao, dadosAssociadoComUpSell);
        showMessageSuccess(
            'Sucesso!',
            'Edição concluida com sucesso.'
        );

        localStorage.removeItem('cep_associado_up_sell');
        setTimeout(() => this.props.history.push({
            pathname: `/cadastrar-dependentes/${this.props.match.params.inscricao}`,
            state: { subGrupoSelecionadoUpSell: this.state.subGrupoSelecionadoUpSell }
        }), 1000);
    }

    voltarTelaAnterior = () => {
        this.props.history.push('/up-sell/');
    }

    updatedFieldDoc(event) {
        const dados = { ...this.state.dados };
        const dataFinalDaPromocaoDeFinados2023 = moment('2024-03-01').utc();
        const dataDeFinados = moment('2023-10-31').utc();
        const dataAtual = moment().utc();
        const estamosNoPeriodoDeFinados = dataAtual.isBetween(
            dataDeFinados,
            dataFinalDaPromocaoDeFinados2023
        );

        if (
            event.target.name === 'AssTipoCobranca' &&
            event.target.value === 1 &&
            estamosNoPeriodoDeFinados
        ) {
            this.setState({ visible: true });
        }

        if (event.target.value === 'M') {
            dados[event.target.name] = event.target.value;
            this.setState({ produtos: this.state.produtosTemp });
            this.setState({ dados });
        }

        if (event.target.value === 'A') {
            dados[event.target.name] = event.target.value;
            this.setState({
                produtos: [
                    {
                        label: 'ZELO PRIME ANUAL',
                        value: 'ZPA'
                    }
                ]
            });
            this.setState({ dados });
        }

        if (event.target.value === 'AT') {
            dados[event.target.name] = event.target.value;
            this.setState({
                produtos: [
                    {
                        label: 'ZELO PRIME 4 ANOS',
                        value: 'ZP4'
                    }
                ]
            });
            this.setState({ dados });
        } else {
            dados[event.target.name] = event.target.value;
            this.setState({ produtos: this.state.produtosTemp });
            this.setState({ dados });
        }
    }

    CEP = async cep => {
        await BuscarCep(cep.replace(/\D/g, ''))
            .then(response => {
                if (!response.erro) {
                    this.setState({ codeIbge: response.ibge });
                    this.setState({ ufLocation: response.uf });

                    const dados = { ...this.state.dados };

                    dados.Cidade = response.localidade.toUpperCase();

                    if (this.state.existeUpSellContrato) {
                        dados.Bairro = response.bairro;
                        dados.Residencia = response.logradouro;
                    } else {
                        dados.Bairro =
                            this.state.dados.Bairro.length > 1 ?
                                this.state.dados.Bairro.toUpperCase() :
                                response.bairro ?
                                    response.bairro.toUpperCase() :
                                    '';
                        dados.Residencia =
                            this.state.dados.Residencia.length > 1 ?
                                this.state.dados.Residencia.toUpperCase() :
                                response.logradouro ?
                                    response.logradouro.toUpperCase() :
                                    '';
                    }

                    this.setState({ dados });
                }
            })
            .catch(error => {
                console.log(error);
            });

        const Uf = this.state.ufLocation === null ? 'MG' : this.state.ufLocation;
        const city = this.state.codeIbge ? this.state.codeIbge : '3106200';
        const { data } = await getProducts(Uf, city, 'Plano');

        if (data) {
            data.forEach(element => {
                element.label = element.Produto.descricao;
                element.value = element.plano;
            });

            if (this.state.codeIbge === '3134608' && !this.state.dados.troca) {
                const subGrupoZSM = ['ZSM', 'ZSMC', 'ZSMT', 'ZSMTC'];
                const subGrupos = {
                    filtrarSubGrupoSobMedidaJaboticatubas() {
                        return data
                            .filter(item => !subGrupoZSM.includes(item.plano.trim()))
                            .map(plano => plano);
                    }
                };

                const filtrado = subGrupos.filtrarSubGrupoSobMedidaJaboticatubas();

                this.setState({ setGrupoRegiao: filtrado });
                this.setState({ setPlanoRegiao: filtrado });

                return;
            }

            if (area == 6) {
                const subgrupoCemiterio = data.find(
                    item => item.plano.trim() == 'ZI'
                );

                this.setState({ setGrupoRegiao: subgrupoCemiterio });
            } else if (area == 3) {
                const subGrupoPrime = data.filter(
                    item => item.plano.trim().substr(0, 2) === 'ZP' && item.plano.trim().substr(0, 4) !== 'ZPET'
                );

                this.setState({ setGrupoRegiao: subGrupoPrime });
            } else if (area == 7) {
                const subGruposAreaSete = [
                    'ZF',
                    'ZT',
                    'ZI',
                    'ZS',
                    'ZTC',
                    'ZFC',
                    'ZT65',
                    'ZTC65',
                    'ZSUC',
                    'ZPET'
                ];

                const subGrupos = {
                    filtrarSubGruposAreaSete() {
                        return data
                            .filter(item =>
                                subGruposAreaSete.includes(item.plano.trim())
                            )
                            .map(plano => plano);
                    }
                };

                this.setState({ setGrupoRegiao: subGrupos.filtrarSubGruposAreaSete() });
            } else if (area == 1) {
                if (opCidadesZPETNExterno.includes(this.state.codeIbge)) {
                    this.setState({ setGrupoRegiao: data });
                    this.setState({ setPlanoRegiao: data });
                } else {
                    const filtroZPETNExterno = data.filter(subGrupo => subGrupo.plano.trim() !== 'ZPETN');

                    this.setState({ setGrupoRegiao: filtroZPETNExterno });
                    this.setState({ setPlanoRegiao: data });
                }
            } else {
                const subgrupoAll = data.filter(
                    item => item.plano.trim().substr(0, 2) !== 'ZP'
                );

                const subGrupoPetNacional = data.filter(
                    item => item.plano.trim() == 'ZPETN'
                );

                subGrupoPetNacional.length > 0 && subgrupoAll.push(subGrupoPetNacional[0]);

                this.setState({ setGrupoRegiao: subgrupoAll });
            }
        }
    };

    buscaOpcaoPagamento = subGrupo => {
        const estado = this.state.ufLocation;

        let opcoesPagamento = area !== '3' ?
            estado === 'ES' ?
                opPagamentoParaES :
                opPagamento :
            estado === 'ES' ?
                opPagamentoParaESPrime :
                opPagamentoPrime;

        if (subGrupo === '') {
            showMessageError('SubGrupo vazio!', 'Favor, selecione um subgrupo!');
        }

        if (subGruposValidos.includes(subGrupo?.trim())) {
            opcoesPagamento = opPagamentoParaESSemBoleto;
        }

        if (
            opcoesPagamento.find(
                item => item.value === this.state.dados.AssTipoCobranca
            ) === undefined
        ) {
            this.setState({
                dados: {
                    ...this.state.dados,
                    AssTipoCobranca: null
                }
            });
        }

        this.setState({ opcoesPagamento });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevState.setGrupoRegiao !== this.state.setGrupoRegiao ||
            prevState.produtos !== this.state.produtos ||
            prevState.dados.SubGrupo !== this.state.dados.SubGrupo) {
            this.atualizaProdutosFiltrados();
        }
    }

    atualizaProdutosFiltrados = () => {
        let produtosFiltrados = this.state.setGrupoRegiao ? this.state.setGrupoRegiao : this.state.produtos;

        if (this.state.dados.SubGrupo.search(/troca/i) !== -1) {
            produtosFiltrados = produtosFiltrados.filter(subGrp => subGrp.label.search(/troca/i) === -1);
        }

        if (this.state.dados.SubGrupo.trim() !== 'ZTA') {
            produtosFiltrados = produtosFiltrados.filter(item => item.plano.trim() !== 'ZTA');
        }

        this.setState({ opProdutos: produtosFiltrados });
    }

    valorBaseSubgrupo = event => {
        this.setState({ selectionSubGrupo: event.target.value });

        const dados = { ...this.state.dados };
        const produtoSelecionado = event.target.value;
        const subGrupoDoPlanoAtual = dados.SubGrupo?.trim();

        dados.SubGrupo = produtoSelecionado;
        this.setState({ dados });

        for (const regiao of this.state.setGrupoRegiao) {
            if (produtoSelecionado === regiao.plano) {
                const { id } = regiao;

                this.setState({ ValorBase: id });
            }
        }

        if (
            produtoSelecionado.trim() !== 'ZI' ||
            produtoSelecionado.trim().substr(0, 2) !== 'ZU'
        ) {
            this.setState({ desabilitarBotao: false });
        }

        this.setValorBaseProduto(produtoSelecionado);
        this.verificaRegrasParaPlanoZI(produtoSelecionado);
        this.verificarRegrasParaPlanoZeloSobMedida(produtoSelecionado);

        if (subGrupoDoPlanoAtual === 'ZTA') {
            this.verificaRegrasParaPlanoZTA(produtoSelecionado, subGrupoDoPlanoAtual);
        }
    };

    render() {
        const header = <img alt="Card" src={fundo_amarelo} />;
        const { subGrupoSelecionadoUpSell } = this.state;
        const isDisabledUpSell = subGrupoSelecionadoUpSell !== null;

        return (
            <>
                {this.state.spinner && (
                    <ProgressSpinner style={{ marginLeft: '50%' }} />
                )}
                {!this.state.spinner && (
                    <Card
                        className="tratar-scroll-card"
                        header={header}
                        title={this.state.titulo}
                    >
                        {!isDisabledUpSell && (
                            <>
                                <DialogVerificacaoPlano
                                    inscricao={this.props.match.params.inscricao}
                                    openModal={this.state.modalPlano}
                                    closeModal={() => this.closeModalPlanoZI()}
                                    subGrupo={this.state.selectionSubGrupo}
                                    foraDicionario={this.state.foraDicionario}
                                    arrayMsgErro={this.state.arrayMsgErroDependente}
                                />

                                <ModalValidacaoAceite
                                    visible={this.state.dados?.Aceite === 'S'}
                                />
                            </>
                        )}
                        <ModalPlanoDesativado
                            status={this.state.dados['ProdutosPreco.status']}
                            plano={this.state.dados['Produto.descricao']}
                            cidade={this.state.dados?.Cidade}
                            closable={true}
                        />
                        <div className="p-grid p-fluid">
                            {this.state.sucesso && (
                                <Message severity="success" text="Assinatura Salva" />
                            )}
                            {this.state.erro && (
                                <Message
                                    severity="error"
                                    text={`Erro: ${this.state.mensagem}`}
                                />
                            )}
                            <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                                <Fieldset legend="Contratante">
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-12">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Nome"
                                                    className="p-col-fixed"
                                                    style={{ width: '50px' }}
                                                >
                                                    Nome
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        placeholder="Nome"
                                                        name="Nome"
                                                        value={this.state.dados.Nome.toUpperCase()}
                                                        onChange={e =>
                                                            this.updatedField(e)
                                                        }
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Telefone"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Celular
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputMask
                                                        mask="(99) 99999-9999"
                                                        name="Celular"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell.Celular :
                                                                this.state.dados.Celular}
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                    //disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Telefone"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Telefone
                                                </label>
                                                <div className="p-col">
                                                    <InputMask
                                                        mask="(99) 9999-9999"
                                                        name="Telefone"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell.Telefone :
                                                                this.state.dados.Telefone || ''
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                    //disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Email"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Email
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="AssEmail"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell.AssEmail :
                                                                this.state.dados.AssEmail?.toUpperCase()
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                    //disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Idade"
                                                    className="p-col-fixed"
                                                    style={{ width: '105px' }}
                                                >
                                                    Nascimento
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputMask
                                                        mask="99/99/9999"
                                                        name="Nascimento"
                                                        value={
                                                            this.state.dados.Nascimento
                                                        }
                                                        onChange={e =>
                                                            this.updatedField(e)
                                                        }
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Email"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    CPF
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputMask
                                                        mask="999.999.999-99"
                                                        name="CPF"
                                                        value={this.state.dados.CPF}
                                                        maxLength="14"
                                                        onChange={e =>
                                                            this.updatedField(e)
                                                        }
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Idade"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    RG
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="RG"
                                                        id="RG"
                                                        value={this.state.dados.RG?.toUpperCase()}
                                                        onChange={e =>
                                                            this.validaRG(e)
                                                        }
                                                        disabled={isDisabledUpSell}
                                                    />
                                                    <span style={{ color: 'red' }}>
                                                        {this.state.valorRg}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Idade"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Sexo
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <Dropdown
                                                        value={this.state.dados.Sexo}
                                                        options={opSexo}
                                                        optionLabel="label"
                                                        optionValue="value"
                                                        name="Sexo"
                                                        id="Sexo"
                                                        onChange={e => {
                                                            this.updatedFieldDoc(e);
                                                        }}
                                                        style={{
                                                            width: '12em'
                                                        }}
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fieldset>
                                <Fieldset legend="Endereço">
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Email"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    CEP{' '}
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="CEPResid"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell.CEPResid :
                                                                this.state.dados.CEPResid
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                        onBlur={e => {
                                                            this.CEP(
                                                                e.target.value
                                                            );
                                                        }}
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Email"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Cidade{' '}
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="Cidade"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell.Cidade :
                                                                this.state.dados.Cidade
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Email"
                                                    className="p-col-fixed"
                                                    style={{ width: '115px' }}
                                                >
                                                    Bairro{' '}
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="Bairro"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell.Bairro :
                                                                this.state.dados.Bairro.toUpperCase()
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Email"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Numero{' '}
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="numeroResidencia"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell.numeroResidencia :
                                                                this.state.dados
                                                                    .numeroResidencia
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                    //disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Email"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Rua/AV{' '}
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="Residencia"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell.Residencia.toUpperCase() :
                                                                this.state.dados.Residencia.toUpperCase()
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    className="p-col-fixed"
                                                    style={{ width: '115px' }}
                                                >
                                                    Complemento
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="Complemento"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell?.Complemento?.toUpperCase() :
                                                                this.state.dados.Complemento.toUpperCase()
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                    // disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Idade"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Referencia
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="AssReferenciaEndereco"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell?.AssReferenciaEndereco :
                                                                this.state.dados.AssReferenciaEndereco.toUpperCase()
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                        maxLength="70"
                                                    //disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Fieldset>
                                <Fieldset legend="Contrato">
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Idade"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    SubGrupo
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <Dropdown
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.subGrupoSelecionadoUpSell :
                                                                this.state.dados.SubGrupo
                                                        }
                                                        options={this.state.opProdutos}
                                                        name="SubGrupo"
                                                        id="SubGrupo"
                                                        dataKey="value"
                                                        onChange={e => {
                                                            this.buscaOpcaoPagamento(
                                                                e.target.value
                                                            );
                                                            this.valorBaseSubgrupo(e);
                                                            this.handleBuscaCemiterio(
                                                                e.target.value
                                                            );
                                                        }}
                                                        style={{
                                                            width: '12em'
                                                        }}
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Idade"
                                                    className="p-col-fixed"
                                                    style={{ width: '90px' }}
                                                >
                                                    Tipo Cobrança
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <Dropdown
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                7 :
                                                                this.state.dados
                                                                    .AssTipoCobranca
                                                        }
                                                        options={
                                                            this.state.opcoesPagamento
                                                        }
                                                        name="AssTipoCobranca"
                                                        id="AssTipoCobranca"
                                                        onChange={e => {
                                                            this.updatedFieldDoc(e);
                                                        }}
                                                        style={{
                                                            width: '12em'
                                                        }}
                                                        disabled={isDisabledUpSell}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Idade"
                                                    className="p-col-fixed"
                                                    style={{ width: '99px' }}
                                                >
                                                    Tipo Mensalidade
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <Dropdown
                                                        value={
                                                            this.state.dados
                                                                .payzentipomensalidade
                                                        }
                                                        options={
                                                            this.state.dados.SubGrupo?.trim().substring(
                                                                0,
                                                                3
                                                            ) === 'ZPC' ?
                                                                opMensalidadeZPC :
                                                                opMensalidade
                                                        }
                                                        name="payzentipomensalidade"
                                                        id="payzentipomensalidade"
                                                        onChange={e => {
                                                            this.updatedFieldDoc(e);
                                                            this.handleBuscaCemiterio(
                                                                e.target.value
                                                            );
                                                        }}
                                                        disabled={isDisabledUpSell}
                                                        style={{
                                                            width: '12em'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field p-grid">
                                                <label
                                                    htmlFor="Idade"
                                                    className="p-col-fixed"
                                                    style={{ width: '100px' }}
                                                >
                                                    Dia Vencimento
                                                    <span style={{ color: 'red' }}>
                                                        <strong>*</strong>
                                                    </span>
                                                </label>
                                                <div className="p-col">
                                                    <InputText
                                                        name="DiaVenc"
                                                        value={
                                                            this.state.existeUpSellContrato ?
                                                                this.state.dadosAssociadoComUpSell?.DiaVenc :
                                                                this.state.dados.DiaVenc
                                                        }
                                                        onChange={e =>
                                                            this.state.existeUpSellContrato ?
                                                                this.updatedFieldUpSell(e) :
                                                                this.updatedField(e)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {(this.state.dados.SubGrupo.trim() === 'ZS' ||
                                            this.state.dados.SubGrupo.trim() ===
                                            'ZSUC') && (
                                                <div className="p-col-12 p-md-4">
                                                    <div className="p-field p-grid">
                                                        <label
                                                            htmlFor="ValorTroca"
                                                            className="p-col-fixed"
                                                            style={{ width: '99px' }}
                                                        >
                                                            Cemitério
                                                            <span style={{ color: 'red' }}>
                                                                <strong>*</strong>
                                                            </span>
                                                        </label>
                                                        <div className="p-col">
                                                            <Dropdown
                                                                required={true}
                                                                onChange={e => {
                                                                    this.updatedFieldDoc(e);
                                                                }}
                                                                value={this.state.dados.idCemiterio}
                                                                name="idCemiterio"
                                                                options={this.state.nomeCemiterio}
                                                                placeholder="Nome cemitério"
                                                                disabled={isDisabledUpSell}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        {(this.state.dados.SubGrupo.trim() === 'ZTA') && (
                                            <>
                                                <div className="p-col-12 p-md-4">
                                                    <div className="p-field p-grid">
                                                        <label
                                                            htmlFor="ValorTroca"
                                                            className="p-col-fixed"
                                                            style={{ width: '99px' }}
                                                        >
                                                            Valor Troca
                                                            <span style={{ color: 'red' }}>
                                                                <strong>*</strong>
                                                            </span>
                                                        </label>
                                                        <div className="p-col">
                                                            <InputText
                                                                name="ProdutosPreco.valorBase"
                                                                value={this.state.dados['ProdutosPreco.valorBase'].toLocaleString('pt-BR', {
                                                                    style: 'currency',
                                                                    currency: 'BRL'
                                                                })}
                                                                onChange={this.handleInputChange}
                                                                placeholder="Valor Troca Aberta"
                                                                disabled={isDisabledUpSell}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                    </div>
                                </Fieldset>
                            </div>
                        </div>

                        <Fieldset legend="Filiação">
                            <div className="p-field p-grid">
                                <label
                                    htmlFor="PaiAssoc"
                                    className="p-col-fixed"
                                    style={{ width: '60px' }}
                                >
                                    Pai
                                </label>
                                <div className="p-col">
                                    <InputText
                                        name="PaiAssoc"
                                        value={this.state.dados.PaiAssoc?.toUpperCase()}
                                        onChange={e => this.updatedField(e)}
                                        style={{ width: '320px' }}
                                        disabled={isDisabledUpSell}
                                    />
                                </div>

                                <label
                                    htmlFor="MaeAssoc"
                                    className="p-col-fixed"
                                    style={{ width: '60px' }}
                                >
                                    Mãe
                                </label>
                                <div className="p-col">
                                    <InputText
                                        name="MaeAssoc"
                                        value={this.state.dados.MaeAssoc?.toUpperCase()}
                                        onChange={e => this.updatedField(e)}
                                        style={{ width: '320px' }}
                                        disabled={isDisabledUpSell}
                                    />
                                </div>
                            </div>
                        </Fieldset>

                        <Fieldset legend="Observação">
                            <InputTextarea
                                name="Obs1"
                                value={
                                    this.state.existeUpSellContrato ?
                                        this.state.dadosAssociadoComUpSell?.Obs1?.toUpperCase() :
                                        this.state.dados.Obs1?.toUpperCase()
                                }
                                maxLength="20"
                                onChange={e =>
                                    this.state.existeUpSellContrato ?
                                        this.updatedFieldUpSell(e) :
                                        this.updatedField(e)
                                }
                            ></InputTextarea>
                        </Fieldset>

                        <br></br>
                        <Dialog
                            header={'Atenção.'}
                            footer={
                                <div className="button-container">
                                    <Button
                                        label="Prosseguir"
                                        icon="pi pi-arrow-right"
                                        onClick={() =>
                                            this.setState({ visible: false })
                                        }
                                    />
                                </div>
                            }
                            visible={this.state.visible}
                            style={{ width: '60vw' }}
                            modal
                            closable={() => this.setState({ visible: false })}
                            showHeader
                            onHide={() => this.setState({ visible: false })}
                        >
                            <div className="dialog-plano">
                                <GoAlert size={50} color="orange" />
                                Ao fazer qualquer alteração da forma de pagamento, os
                                critérios de bonificação e desconto de adesão podem
                                sofrer alterações.
                            </div>
                        </Dialog>
                        {this.state.existeUpSellContrato ? (
                            <>
                                <Button
                                    type="submit"
                                    label="Prosseguir"
                                    onClick={() => this.saveUpSell()}
                                />
                                <Button
                                    className="p-button-warning"
                                    style={{ marginLeft: '8px' }}
                                    label="Voltar"
                                    onClick={() => this.voltarTelaAnterior()}
                                />
                            </>
                        ) : (
                            <Button
                                type="submit"
                                disabled={this.state.desabilitarBotao}
                                label="Salvar"
                                onClick={() => this.save()}
                            />
                        )}
                    </Card>
                )}
            </>
        );
    }
}

export default editarAssociados;